<mat-form-field>
	<mat-label>{{ label }}</mat-label>
	<input
		type="text"
		matInput
		class="cmms-cost-input"
		mask="separator.2"
		decimalMarker="."
		[formControl]="formControl"
		[value]="formControl.value | mask: 'separator.2'"
		(blur)="emitValueChange()"
		(keydown.enter)="emitValueChange()"
	/>
	<span matSuffix class="cmms-cost-currency-type">NOK</span>
</mat-form-field>
